function IsJSON(str: string | null | undefined) {
  if (typeof str !== 'string') return false;
  if(typeof str === 'string') {
    try {
      let obj = JSON.parse(str);
      console.log('转换成功：' + obj);
      return true;
    } catch (e) {
      return false;
    }
  }
}　

export default IsJSON
